// components/Stats/StepsCard.jsx
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "@tanstack/react-router";
import StatCard from "./statCard";
import { FaBookOpen } from "react-icons/fa";
import { Settings } from "lucide-react";
import axios from "axios";
import { courseContent } from "../../data/courseContent";

export default function StepsCard({ count, onActionClick, onSwitchTab }) {
  const navigate = useNavigate();
  const { courseId } = useParams({ strict: false });

  const handleClick = () => {
    navigate({
      to: `/manage-course/${courseId}`,
      state: { tab: "content" },
    });
  };

  // const handleClick = onActionClick
  //   ?? (() => document.querySelector('[value="content"]').click())

  const steps = courseContent.steps;
  const description = courseContent.stepDescription;

  return (
    <StatCard
      icon={<FaBookOpen className="w-6 h-6" />}
      label="Course Steps"
      value={count}
      subtitle={description}
      actionText="Manage Content"
      actionIcon={<Settings className="w-4 h-4" />}
      actionVariant="outline"
      actionOnClick={() => onSwitchTab("content")}
    />
  );
}
